import { _ } from "../../../core/polyglot/polyglot.js";
import Entry from "../../../models/accounting/document/Entry.js";

/**
 * I am a strategy pattern used to sort the entries in the rendering phase
 * (cf. http://en.wikipedia.org/wiki/Strategy_pattern)
 */

function abstractSortingStrategy(spec) {
	spec ||= {};

	const that = {};

	const name = spec.name;
	const sortingFunction = spec.sortingFunction;
	const icon = spec.icon;

	that.name = function () {
		return name;
	};

	that.sortingFunction = function () {
		return sortingFunction;
	};

	that.icon = function () {
		return icon;
	};

	return that;
}

/**
 * Flyweight pattern. Strategies are stateless and reused,
 * strict comparison is used on them.
 * (cf. http://en.wikipedia.org/wiki/Flyweight_pattern)
 */

export default {
	sortByNameAZStrategy: abstractSortingStrategy({
		name: _("Name ascending"),
		sortingFunction: Entry.sortByNameAZStrategy,
		icon: "fas fa-sort-alpha-down",
	}),
	sortByNameZAStrategy: abstractSortingStrategy({
		name: _("Name descending"),
		sortingFunction: Entry.sortByNameZAStrategy,
		icon: "fas fa-sort-alpha-down-alt",
	}),
	sortByCreationTimeAscStrategy: abstractSortingStrategy({
		name: _("Creation time ascending"),
		sortingFunction: Entry.sortByCreationTimeAscStrategy,
		icon: "fas fa-sort-amount-down",
	}),
	sortByCreationTimeDescStrategy: abstractSortingStrategy({
		name: _("Creation time descending"),
		sortingFunction: Entry.sortByCreationTimeDescStrategy,
		icon: "fas fa-sort-amount-down-alt",
	}),
	sortByModificationTimeAscStrategy: abstractSortingStrategy({
		name: _("Last modification ascending"),
		sortingFunction: Entry.sortByModificationTimeAscStrategy,
		icon: "fas fa-sort-amount-down",
	}),
	sortByModificationTimeDescStrategy: abstractSortingStrategy({
		name: _("Last modification descending"),
		sortingFunction: Entry.sortByModificationTimeDescStrategy,
		icon: "fas fa-sort-amount-down-alt",
	}),
};
